import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';

const DuplicateDialog = ({
  open,
  onCancel,
  onConfirm,
  newTitle,
  setNewTitle
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Duplicate Topic</DialogTitle>
      <DialogContent>
        <TextField
          margin="normal"
          fullWidth
          variant="outlined"
          value={newTitle}
          onChange={(e) => setNewTitle(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>
          Duplicate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicateDialog;
